import React from "react";

const Categoryform = ({ handleSubmit, value, setValue }) => {
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Introduzca un nuevo campo"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={{ width: "70%" }}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Crear 
        </button>
      </form>
    </>
  );
};
// Cap 18
export default Categoryform;
